import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { formatUsd } from "@kontextwerk/web-common";

import type { CostSummaryBucket } from "../lib/types";

interface Props {
  buckets: CostSummaryBucket[];
  height?: number;
  topN?: number;
}

const PALETTE = ["#7C5CFF", "#14B8A6", "#4DD0E1", "#FBBF24", "#A78BFA", "#5EEAD4"];

export default function StackedBreakdownChart({
  buckets,
  height = 240,
  topN = 12,
}: Props) {
  const top = [...buckets]
    .sort((a, b) => b.total_cost_usd - a.total_cost_usd)
    .slice(0, topN);
  if (top.length === 0) {
    return (
      <div className="text-sm text-kw-text-faint py-8 text-center">
        Keine Daten.
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={top} margin={{ top: 8, right: 24, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#1E2547" />
        <XAxis
          dataKey="group_key"
          tick={{ fontSize: 11, fill: "#94A3B8" }}
          interval={0}
          angle={-30}
          textAnchor="end"
          height={60}
        />
        <YAxis
          tickFormatter={(v) => formatUsd(v)}
          tick={{ fontSize: 11, fill: "#94A3B8" }}
          width={92}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "#141A38",
            border: "1px solid #2A3358",
            fontSize: "12px",
          }}
          formatter={(value: number) => formatUsd(value)}
        />
        <Bar dataKey="total_cost_usd">
          {top.map((_, idx) => (
            <Cell key={idx} fill={PALETTE[idx % PALETTE.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
